import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
// import videoHome from "../views/videoHome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index.html"
  },
  {
    path: "/index.html",
    component: () => import("../views/Index.vue")
  },
  {
    path: "/fixTopic.html",
    component: () => import("../views/fixTopic.vue")
  },
  {
    path: "/post.html",
    component: () => import("../views/postDetail.vue")
  },
  {
    path: "/search.html",
    component: () => import("../views/search.vue")
  },
  {
    path: "/localCity.html",
    component: () => import("../views/localCity.vue")
  },
  {
    path: "/local.html",
    component: () => import("../views/local.vue")
  },
  {
    path: "/upPost.html",
    component: () => import("../views/upPost.vue")
  },
  {
    path: "/myPost.html",
    component: () => import("../views/myPost.vue")
  },
  {
    path: "/myInfo.html",
    component: () => import("../views/myInfo.vue")
  },
  {
    path: "/updataInfo.html",
    component: () => import("../views/updataInfo.vue")
  },
  {
    path: "/updataPassWord.html",
    component: () => import("../views/updataPassWord.vue")
  },
  {
    path: "/bindMobile.html",
    component: () => import("../views/bindMobile.vue")
  },
  {
    path: "/catalog.html",
    component: () => import("../views/catalog.vue")
  },
  {
    path: "/uploadVideo.html",
    component: () => import("../views/uploadVideo.vue")
  },
  {
    path: "/noticeDetail.html",
    component: () => import("../views/noticeDetail.vue")
  },
  {
    path: "/notice.html",
    component: () => import("../views/notice.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
